import { useEffect } from 'react';
import { selectSearchAppliedTerm } from 'common/features/store/duck/search/duck';
import { useRootSelector } from 'rootStore';
import { tempStorage } from 'common/api/constructor';
import { constructorInstance } from 'common/api/constructor/constructor-instance';

export const constructorClient = constructorInstance;

// FEC-1622:
export const removeConstructorRefinedContent = () => {
    tempStorage.set(undefined);
};

export const useManageConstructorRefinedContent = () => {
    const searchTerm = useRootSelector(selectSearchAppliedTerm);

    useEffect(() => {
        if (searchTerm === '') {
            removeConstructorRefinedContent();
        }
    }, [searchTerm]);
};
// FEC-1622
